<template>
  <div>
    <div class="flex justify-center">
      <button v-if="showReorderButton && tracks.length > 10" @click="confirmTracksOrderChange"
        class="w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor">
        {{ $t("tracks.editTrack.saveChanges") }}
      </button>
    </div>
    <div v-show="loading" class="flex justify-center mt3 textColor">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div class="track-list-header h2 w-95 mb1 textColor displayNone">
      <p class="fl w-10 h-100 ma0 textColor"></p>
      <p class="fl w-30 h-100 pa1 pl8 ma0 text-ellipsis center-content b textColor">
        {{ $t("tracks.headers.title") }}
      </p>
      <p class="fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content b textColor"></p>
      <p class="fl w-20 h-100 pa1 ma0 text-ellipsis center-content b textColor dw-163">
        {{ $t("tracks.headers.genre") }}
      </p>
      <p class="released fl w-15 h-100 pa1 ma0 center-content b textColor">
        {{ $t("tracks.headers.duration") }}
      </p>
      <p class="fl w-5 h-100 ma0"></p>
    </div>
    <div class="ph5-l">
      <transition name="fade">
        <div class="flex flex-column self-end pr1 pl1 textColor">
          <draggable v-model="tracks" :options="options">
            <div class="bb b--black-05 pa1 nowrap textColor relative mb2" v-for="(track, index) in tracks"
                  :key="index"
                  :class="{'track-playing' : track === currentTrack}">
              <div class="drag-icon dib v-mid ma0 pointer textColor">
                <font-awesome-icon icon="bars" size="lg"></font-awesome-icon>
              </div>
              <track-item-list
                  :track="track"
                  :profileTracks="true"
                  @play="setPlaylist(tracks)"
                  class="item-container dib v-mid vw66"
                ></track-item-list>
            </div>
          </draggable>
        </div>
      </transition>
    </div>
    <div class="flex justify-center">
      <button v-if="showReorderButton" @click="confirmTracksOrderChange"
        class="w-30-l w-50-m w-100 block mv2 pointer btn dim b f5 fw4 textColor">
        {{ $t("tracks.editTrack.saveChanges") }}
      </button>
    </div>
    <!--<tracks-list v-show="!loading" :tracks="tracks" :withFilters="false" :withPagination="false"
                 :loading="loading" :profileTracks="true"></tracks-list>-->
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TracksList from '@/components/tracks/TracksList.vue'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import draggable from 'vuedraggable'
  import TrackItemList from '@/components/tracks/TrackItemList.vue'

  export default {
    name: 'my-tracks',
    components: {
      TracksList,
      ClipLoader,
      draggable,
      TrackItemList
    },
    data () {
      return {
        color: '#808080',
        size: '30px',
        tracks: null,
        showReorderButton: false
      }
    },
    watch: {
      myTracks: function (newTracks, oldTracks) {
        if (this.myTracks) {
          this.tracks = this.myTracks
        }
      },
      tracks: function (newTracks, oldTracks) {
        let oldPosition = this.myTracks.map((x) => { return x.id })
        let newPosition = this.tracks.map((x) => { return x.id })
        oldPosition.forEach((id, idx) => {
          if (newPosition.indexOf(id) !== idx) {
            this.showReorderButton = true
          }
        })
      }
    },
    created () {
      this.getMyTracks().catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
      this.getMyArtistInfo().catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    },
    computed: {
      ...mapGetters('user', [
        'myTracks',
        'error',
        'loading'
      ]),
      ...mapGetters('artist', [
        'myArtistInfo'
      ]),
      ...mapGetters('player', [
        'currentTrack'
      ]),
      options () {
        return {
          handle: '.drag-icon'
        }
      }
    },
    methods: {
      ...mapActions('user', [
        'getMyTracks'
      ]),
      ...mapActions('track', [
        'setMyTrackOrder'
      ]),
      ...mapActions('artist', [
        'getMyArtistInfo'
      ]),
      ...mapActions('player', [
        'setPlaylist'
      ]),
      confirmTracksOrderChange () {
        let newOrder = []
        this.tracks.forEach((track, idx) => {
          newOrder.push({
            track_id: track.id,
            order_position: idx + 1
          })
        })
        this.setMyTrackOrder({
          artist_id: this.myArtistInfo.id,
          reorder: newOrder
        }).then(res => {
          if (res === 'ok') {
            this.$toasted.show(this.$t('tracks.editTrack.listUploaded'), {type: 'success'})
            this.showReorderButton = false
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  
  @media (min-width: 600px) {
    .dw-163{
      width: 163px;
    }
    .vw66 {
      width: 66vw;
    }
    .pl8 {
      padding-left: 5.5rem;
    }
  }
  @media (max-width: 600px) {
    .displayNone {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/MyTracks.vue